import { GoogleGenAI } from "@google/genai";

// Set up your GoogleGenAI instance with the API key.
const ai = new GoogleGenAI({
  apiKey: "AIzaSyBrwxqxPj_kvb-dwX6sg0w7VmMT1SbIMyA",
});

// Helper function to generate part of the recipe
const generatePart = async (prompt) => {
  const response = await ai.models.generateContent({
    model: "gemini-2.0-flash-exp",
    contents: prompt,
  });
  return response.text.trim();
};

// Helper function to generate an image URL based on the dish name
export const generateRecipe = async (
  dietaryRestrictions,
  allergies,
  country,
  userIngredients,
  onlyUseTheseIngredients
) => {
  try {
    // Shared context to ensure consistency across prompts
    const context = `
      Dietary restrictions: ${dietaryRestrictions}
      Allergies: ${allergies}
      Preferred country or cuisine: ${country}
      Ingredients available: ${userIngredients}
       ${onlyUseTheseIngredients ? "You must only use listed ingredients" : "Must include listed ingredients but must use others"}
    `.trim();

    // Generate the recipe title
    const titlePrompt = `
      Based on the following context, generate only the name of a unique and interesting recipe that does not take too many steps and easy-to-find ingredients(less than 20). Do NOT include any additional text or formatting.
      Make sure to recipe title can follows the ingredients available.
      If ingredients are inappropriate do not provide response.(the quantity does not matter)
      ${context}
    `;
    const recipeTitle = await generatePart(titlePrompt);

    // Generate the ingredients list
    const ingredientsPrompt = `
      Based on the following context, list ONLY the food ingredients (one per line, capitalized first letter, Add a note of where (specific store names in parenthesis) you can buy each ingredients in same line ) required for the recipe "${recipeTitle}". Do NOT include a title or introductory sentence.
      If ingredients are inappropriate do not provide response. (the quantity does not matter)
      ${context}
    `;
    const ingredientsText = await generatePart(ingredientsPrompt);
    const ingredients = ingredientsText.split("\n").map(line => line.trim()).filter(line => line);

    // Generate the instructions
   // Updated instructionsPrompt
const instructionsPrompt = `
Based on the following context, write clear step-by-step instructions for how to prepare the recipe titled "${recipeTitle}".
Use the following ingredients:

${ingredients.join("\n")}


Context:
${context}

Write one instruction per line. Do NOT use numbering.
If ingredients are inappropriate do not provide response.
(the quantity does not matter)
`;

    const instructionsText = await generatePart(instructionsPrompt);
    const instructions = instructionsText.split("\n").map(line => line.trim()).filter(line => line);

    // Generate the image URL

    return {
      recipe: recipeTitle,
      ingredients,
      instructions,
    };
  } catch (error) {
    console.error("Error generating recipe:", error);
    throw new Error("Failed to generate recipe.");
  }
};